import { Dialog, DialogContent } from "@/view/components/ui/dialog"
import { DialogHeader } from "@/view/components/ui/dialog"
import { DialogTitle } from "@/view/components/ui/dialog"
import { DialogDescription } from "@radix-ui/react-dialog";
import { CloseCircle } from "iconsax-react";

interface ErrorModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
}

export const ErrorModal = ({ isOpen, onOpenChange }: ErrorModalProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent variant="bottomSheet" className="gap-2 max-w-sm rounded-xl sm:rounded-xl" classNameCloseIcon="text-red-500 [&>svg]:w-5 [&>svg]:h-5 opacity-100">
        <DialogHeader className="flex items-center ">
          <CloseCircle className="text-red-500 w-12 h-12" />
          <DialogTitle className="text-2xl font-bold dark:text-white">Proposta Negada</DialogTitle>
        </DialogHeader>
        <DialogDescription className="text-center text-sm font-semibold pb-6 dark:text-gray-300">
          Cliente não possui ofertas disponíveis no momento
        </DialogDescription>
      </DialogContent>
    </Dialog>
  )
}